import ERRORS from '@/translation/errors_translation';

import NL from '@/translation/languages/NL';
import EN from '@/translation/languages/EN';
import DE from '@/translation/languages/DE';

import store from '@/store';

const translations = {
  NL,
  EN,
  DE,
};

function getUserLanguageCode() {
  let code = '';
  switch (Number(store.getters['auth/userLanguage'].LanguageId)) {
    case 13:
      code = 'EN';
      break;
    case 14:
      code = 'NL';
      break;
    case 17:
      code = 'DE';
      break;
    default:
      code = 'EN';
  }

  return code;
}

/**
 * @brief Get a translated text based on user language selection
 * @param {string} text The text to be translated, which is the key in the language file
 * @returns Translated text
 */
function translate(text) {
  const lang = getUserLanguageCode();

  let textTranslation = text;

  if (translations[lang][text] != null) {
    textTranslation = translations[lang][text];
  } else {
    console.error(`TRANSLATE ERROR: Could not find translation for key: ${text}`);
  }

  return textTranslation;
}

/**
 * @brief Get a translated error message based on user language selection
 * @param {string} errorCode The error code received via dss request, e.g. E_DA_001
 * @returns {string} The translated error message
 */
function translateError(errorCode) {
  const lang = getUserLanguageCode();

  let errorTranslation = ERRORS[lang].DEFAULT;

  if (errorCode == null) {
    // Invalid error code
    return errorTranslation;
  }

  if (ERRORS[lang][errorCode] == null) {
    // Error code not defined
    const errorCodeText = ERRORS[lang].ERROR_CODE;
    return `${errorTranslation} ${errorCodeText}: ${errorCode}`;
  }

  errorTranslation = ERRORS[lang][errorCode];

  return errorTranslation;
}

export { translate, translateError };
